import { IShader, ShaderBase } from '../shader';
import { StandardMaterial, Color3, Texture, Scene, Material } from '@babylonjs/core';
import { stringUtil } from '@/models/stringUtil';

export class ShaderShadow extends ShaderBase implements IShader {

    public diffuse: string = '';
    public normal: string = '';
    public avatar: string = '';
    public text: string = '';

    public get key(): string { return 'ShaderShadow'; }

    public getMaterial(scene: Scene, light: string = ''): StandardMaterial {
        const material = new StandardMaterial('material', scene);
        material.diffuseColor = new Color3(0.8, 0.8, 0.8);

        if (light) {
            const url = stringUtil.createDownloadUrl(light);
            const opacityTexture = new Texture(url, scene);
            opacityTexture.coordinatesIndex = 1;
            opacityTexture.vScale = -1;
            material.opacityTexture = opacityTexture;
        }

        material.backFaceCulling = false;
        return material;
    }

    addLight(scene: Scene, material: Material, light: string): Material {
        const url = stringUtil.createDownloadUrl(light);
        const opacityTexture = new Texture(url, scene);
        opacityTexture.coordinatesIndex = 1;
        opacityTexture.vScale = -1;
        (material as StandardMaterial).opacityTexture = opacityTexture;

        return material;
    }
}
